import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, MapPin, Instagram, Facebook } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${API}/categories`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <footer className="bg-card border-t border-border/30 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="font-heading text-2xl font-medium text-foreground">
              Artisan Bridge <span className="text-primary">Home</span>
            </h3>
            <p className="font-body text-sm text-foreground/50 leading-relaxed">
              Where Global Homes Meet Artisan Craft.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="text-foreground/40 hover:text-primary transition-colors" data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-foreground/40 hover:text-primary transition-colors" data-testid="social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Dynamic Categories */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium text-foreground">Collections</h4>
            <nav className="flex flex-col gap-2">
              {categories.map((category) => (
                <Link 
                  key={category.id}
                  to={`/category/${category.id}`} 
                  className="text-sm text-foreground/50 hover:text-primary transition-colors"
                  data-testid={`footer-${category.id}`}
                >
                  {category.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium text-foreground">Navigation</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground/50 hover:text-primary transition-colors" data-testid="footer-home">
                Home
              </Link>
              <Link to="/about" className="text-sm text-foreground/50 hover:text-primary transition-colors" data-testid="footer-about">
                About Us
              </Link>
              <Link to="/featured" className="text-sm text-foreground/50 hover:text-primary transition-colors" data-testid="footer-featured">
                Featured
              </Link>
              <Link to="/admin/login" className="text-sm text-foreground/50 hover:text-primary transition-colors" data-testid="footer-admin">
                Admin
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading text-lg font-medium text-foreground">Contact</h4>
            <div className="flex flex-col gap-3">
              <a href="mailto:hello@artisanbridgehome.com" className="flex items-center gap-2 text-sm text-foreground/50 hover:text-primary transition-colors" data-testid="contact-email">
                <Mail className="w-4 h-4" />
                hello@artisanbridgehome.com
              </a>
              <p className="flex items-start gap-2 text-sm text-foreground/50">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                Delhi, India
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-border/30 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-foreground/40">
            © {new Date().getFullYear()} Artisan Bridge Home. All rights reserved.
          </p>
          <p className="text-xs text-foreground/40">
            Enquiries welcome
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
